module.exports = __webpack_public_path__ + "static/media/Monday_Step4_Image14.d93fbf61.jpg";